import { ReactNode, RefObject } from 'react';
import ChevronDown from '@square-icons/react/24/UI/chevron-down';
import { CTA_SUBNAV_CLASSNAME } from '../shared/constants';
import styles from './mobile_header.module.scss';

export interface MobileHeaderProps {
  titleChild: ReactNode;
  hasNavLinks: boolean;
  openModal: () => void;
  headerRef: RefObject<HTMLDivElement>;
}

/**
 * Mobile header layout component
 * Becomes sticky when scrolling
 * Displays as a button if nav links exist, otherwise shows simple title bar
 * Button opens modal when clicked
 */
const MobileHeader = ({
  titleChild,
  hasNavLinks,
  openModal,
  headerRef,
}: MobileHeaderProps) => {
  return (
    <div
      ref={headerRef}
      className={`${styles.headerNav} ${CTA_SUBNAV_CLASSNAME}`}
      data-mobile-header-nav
      data-testid="cta-subnav-mobile-header"
    >
      {hasNavLinks ? (
        <button
          className={styles.modalToggle}
          onClick={openModal}
          data-testid="cta-subnav-mobile-header-toggle"
        >
          <div className={styles.titleContainer}>
            {titleChild}
            <ChevronDown />
          </div>
        </button>
      ) : (
        <div className={styles.simpleTitleBar}>
          <div className={styles.titleContainer}>{titleChild}</div>
        </div>
      )}
    </div>
  );
};

export default MobileHeader;
